// src/store/index.js
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const getInitialUserInfo = () => {
  const userInfoString = localStorage.getItem("user_info");
  if (!userInfoString || userInfoString === "undefined") {
    return null;
  }
  try {
    return JSON.parse(userInfoString);
  } catch (e) {
    console.error("Error parsing user_info from localStorage", e);
    return null;
  }
};

export default new Vuex.Store({
  state: {
    isLoggedIn: !!localStorage.getItem("token"),
    userInfo: getInitialUserInfo(),
    controlLang: null,
  },
  mutations: {
    SET_LOGIN_STATUS(state, status) {
      state.isLoggedIn = status;
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo;
    },
    SET_CONTROL_LANG(state, lang) {
      state.controlLang = lang;
      localStorage.setItem("control_lang", lang);
    },
  },
  actions: {
    loginSuccess({ commit }, { token, userInfo }) {
      localStorage.setItem("token", token);
      localStorage.setItem("user_info", JSON.stringify(userInfo || null));
      commit("SET_LOGIN_STATUS", true);
      commit("SET_USER_INFO", userInfo || null);
    },
    logout({ commit }) {
      localStorage.removeItem("token");
      localStorage.removeItem("user_info");
      commit("SET_LOGIN_STATUS", false);
      commit("SET_USER_INFO", null);
    },
  },
  getters: {
    isLoggedIn: (state) => state.isLoggedIn,
    userInfo: (state) => state.userInfo,
    controlLang: (state) =>
      state.controlLang || localStorage.getItem("control_lang") || "zh",
  },
});
